import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {SharedService} from '../../services/shared.service';

@Component({
  selector: 'app-foto',
  templateUrl: './foto.component.html',
  styleUrls: ['./foto.component.scss'],
})

export class FotoComponent implements OnInit {

  @ViewChild('camera') camera: ElementRef;
  @Input() data: string;
  @Input() tipo = 'imagen';
  @Input() edit = true;

  SINFOTO: string;
  imageChangedEvent: any = '';
  imagen: any = '';
  titulo = 'CAMBIAR FOTO'

  constructor(
    public shared: SharedService,
    public modalCtrl: ModalController
  ) {}

  ngOnInit() {
    if (!this.edit) {
      this.titulo = 'FOTO'
    }
    this.SINFOTO = this.tipo === 'educadora' ? this.shared.SINFOTOEDUCADORA :
      (this.tipo === 'alumno') ? this.shared.SINFOTOALUMNO : this.shared.SINIMAGEN;
  }

  elegirFoto = () => this.camera.nativeElement.click();

  resize = (ev: any) => this.imageChangedEvent = ev;

  image = (ev: any) => this.imagen = ev;

  save = () => this.modalCtrl.dismiss(this.imagen.base64);

  eliminarFoto = () => this.modalCtrl.dismiss('eliminar');

}
